<div class="not-found-container" [class.unauthorised]="statusCode == 401">
  @if(statusCode == 401){
  <div class="error-container">
    <div class="session-error">
      <nuc-icon iconClass="report_problem" size="32"></nuc-icon>
      <p>Session Timeout</p>
    </div>
    <p class="session-error-text">For security reasons, your session has timed out. Please <a
        (click)="goBackToLogin()" style="cursor:pointer">click here</a> to login again.</p>
  </div>
  }
  @else if(unauthorizedUser){
  <p >{{'Access Denied : You don’t have the required permissions to proceed. Please request the necessary \'GPPLU Service Access\' through Reunis.'}}</p>
  }
  @else{
  <h1>{{statusCode}}</h1>
  <p>Session has expired</p>
  <p>Please click below to re-login</p>
  <a (click)="goBackToLogin()" style="cursor:pointer">Go back to Login</a>
  }
</div>